import styled from "styled-components";

export const PlaylistStyle1 = styled.div`
  color: ${(props) => props.theme.colors.primary};
  background: #111823;
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(8px);
  .ant-dropdown {
    z-index: 100 !important;
  }
  .playListMenu{
    padding: 6px 8px;
    display: flex;
    align-items: center;
    border-radius: 6px;
    transition: all 0.15s ease;
    cursor: pointer;
    opacity: 0.9;
  }
  .playListMenu:hover{
    opacity: 1;
    background: rgba(255, 255, 255, 0.08);
    transform: translateX(1px);
  }
  .playListMenuText{
    font-family: Poppins;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: -0.01em;
    text-align: left;
    margin-left: 10px;
    color: #ffffff;
  }
  .playListMenuSvg {
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg, span {
      width: 18px;
      height: 18px;
      line-height: 18px;
    }
  }
  .row4 {
    display: flex;
    // justify-content: space-around;
    align-items: center;
    padding: 10px 15px 10px 15px;
    cursor: pointer;
    color: ${(props) => props.theme.colors.primary};
  }
  .row4:hover {
    background: rgb(196, 196, 196, 0.3);
    border-radius: 8px;
  }
  .ant-pagination-item-active {
    background: #007aff !important;
  }
`;
